import React from 'react'
import InterestedIn from './InterestedIn'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';

export default function About() {
  document.title = "Portfolio - ABOUT"
    const codeString = `// I can, because I did.
  // My vast variety of skills is continuously expanding.
  class AdarshMaurya {
    // Constructor
    constructor() {
      this.name = 'Adarsh Maurya';
      this.dayOfBirthTimestamp = 1060896000;
      this.email = '54.adarsh.maurya@gmail.com';
    }

    // Education method
    education() {
      return [
        { '2021 - 2024': 'IGNOU - BCA(Bachelor of Computer Applications), Computer Science (IT)' }
      ];
    }

    // Skills method
    skills() {
      return [ 'HTML/CSS/JS', 'Bootstrap', 'React js', 'MySQL' ];
    }
  }`;

    return (
        <section className="about-content">
            <h1 className="after-line">About me</h1>
            <h3 className="heading">Learn more about me</h3>
            <div className="intro">
                <h4 className="leftside-line">Adarsh Maurya</h4>
                <SyntaxHighlighter language="javascript" style={tomorrow}>
                    {codeString}
                </SyntaxHighlighter>
            </div>
            <p><i className="fa-solid fa-quote-left"></i> I don't believe in going to the best. I believe in building the best
                by being better and better. <i className="fa-solid fa-quote-right"></i></p>
            <h1 className="after-line">interests</h1>
            <InterestedIn />
        </section>
    )
}
